import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledConversationPreviewColumn = styled.div`
    display: flex;
    flex-direction: column;
    width: 32%;
    @media ${breakpoints.xs} {
        width: 100%;
    }
    .conversation-preview-action-icons {
        margin-right: 8px;
        margin-left: 8px;
        svg {
            width: 24px;
            cursor: pointer;
        }
    }
    .conversation-title-message {
        flex: 1 0 auto;
        font-size: var(--size-18);
        font-weight: bold;
        line-height: 27px;
        color: var(--color-primary);
        text-align: center;
    }
    .search {
        background: transparent;
        border-top: 1px solid var(--color-grey-700);
        border-right: 1px solid var(--color-grey-700);
        border-radius: unset;
        box-shadow: none;
        .searchIcon {
            svg {
                path {
                    fill: var(--color-grey-800);
                }
            }
        }
        input {
            font-size: var(--size-12);
            font-style: italic;
            font-weight: 400;
            line-height: 18px;
            color: var(--color-grey-800);
        }
    }
    .conversation-empty-message {
        display: flex;
        flex-grow: 1;
        border-top: 1px solid var(--color-grey-700);
        border-right: 1px solid var(--color-grey-700);
        span {
            margin: auto;
            font-size: var(--size-16);
            font-style: italic;
            color: var(--color-grey-800);
        }
    }
`;
